"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedactedAutotTestStep = void 0;
const purify_ts_1 = require("purify-ts");
const non_empty_list_1 = require("@codegrade/non-empty-list");
const base_1 = require("./base");
const utils_1 = require("./utils");
class RedactedAutotTestStep extends base_1.BaseAutoTestStep {
    parseInputData(data) {
        return data;
    }
    getDataToSave() {
        return (0, utils_1.mergeEithers)(this._baseGetDataToSave(), (0, purify_ts_1.Left)((0, non_empty_list_1.NonEmptyList)(['It is nota allowed to edit redacted tests.'])));
    }
}
exports.RedactedAutotTestStep = RedactedAutotTestStep;
